import type { AdminProduct,AdminProductInventorySummary, AdminProductMaterial } from '../../interfaces';


export const getMaterialInventories = (productId: string, material: AdminProductMaterial) =>
  (material.variantInventories || []).filter((variant) =>
    !variant.product?.id || variant.product.id === productId
  );

export const getMaterialStock = (
  productId: string,
  material: AdminProductMaterial,
  requiresSizes: boolean
) => {
  const inventories = getMaterialInventories(productId, material);

  if (requiresSizes && inventories.length) {
    return inventories.reduce((sum, variant) => sum + Number(variant.stockQuantity || 0), 0);
  }

  return Number(material.stockQuantity || inventories[0]?.stockQuantity || 0);
};

export const hasMaterialDetails = (material: AdminProductMaterial) =>
  Array.isArray(material.sizes) ||
  Array.isArray(material.variantInventories) ||
  Array.isArray(material.productImages);

export const getProductInventorySummary = (
  product: AdminProduct,
  requiresSizes: boolean
): AdminProductInventorySummary => {
  const loadedMaterials = product.materialPrices.filter(hasMaterialDetails);
  const totalStock = loadedMaterials.reduce(
    (sum, material) => sum + getMaterialStock(product.id, material, requiresSizes),
    0
  );
  const variantCount = loadedMaterials.reduce(
    (sum, material) => sum + getMaterialInventories(product.id, material).length,
    0
  );

  return {
    loadedMaterialsCount: loadedMaterials.length,
    activeMaterialsCount: product.materialPrices.filter((material) => material.isAvailable).length,
    totalStock,
    variantCount,
  };
};
